import * as api from "@/api/api"; //引入对应的api
export default {
  formMarks: [
    {
      value: "PURCHASE",
      lable: "采购报审单",
    },
    {
      value: "PRINTFORM",
      lable: "用印表单",
    },
    {
      value: "FORMCONTRACTAPP",
      lable: "合同审批表单",
    },
    {
      value: "FORMPAY",
      lable: "付款表单",
    },
    {
      value: "FORMINVOIC",
      lable: "开票表单",
    }],

  //获取当前时间
  GetNowDate() {
    var now = new Date();
    var year = now.getFullYear();      　　 //年
    var month = now.getMonth() + 1;     //月
    var day = now.getDate();            　　//日
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return year + "-" + month + "-" + day;
  },

  //获取当前时分秒
  GetNowTime() {
    var now = new Date();         　　//日
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    if (minute < 10) {
      minute = "0" + minute;
    }
    if (second < 10) {
      second = "0" + second;
    }
    return hour + ":" + minute + ":" + second;
  },

  //数字转大写 非小数
  numberToChinese(num, type = '') {
    if (!num) return 0
    const strNum = Number((num + '').replace(/[,，]*/g, '')) + '' // 记录字符
    num = parseInt(Number(strNum)) // 转为整数，
    let capitalAr = '零一二三四五六七八九十'
    let unitAr = ['十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千']
    if (type) {
      capitalAr = '零壹贰叁肆伍陆柒捌玖拾'
      unitAr = ['拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'] // 单位
    }
    const resultAr = [] // 记录结果，后边json.in就可
    let index = strNum.length - 1 //记录位数
    let idx = 0 // 记录单位
    let percent = 10
    const turnNum = (num, percent, index) => {
      const unit = num / percent
      const capital = capitalAr[Number(strNum[index])]
      if (unit < 1) {
        resultAr.push(capital)
        // 出现11【一十一】这种情况
        if (Number(strNum[index]) === 1 && (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)) {
          resultAr.pop()
        }
        return false //结束递归
      } else {
        if (capital === '零') {
          // 万和亿单位不删除
          if (!['万', '亿'].includes(resultAr[resultAr.length - 1])) {
            resultAr.pop()
          }
          // 前面有零在删掉一个零
          if (resultAr[resultAr.length - 1] === '零') {
            resultAr.pop()
          }
        }
        resultAr.push(capital)
        // 过滤存在【零万】【零亿】这种情况
        if (['万', '亿'].includes(resultAr[resultAr.length - 2]) && capital === '零') {
          resultAr.pop()
        }
        // 过滤【1亿万】这种情况
        if (resultAr[0] === '万' && resultAr[1] === '亿') {
          resultAr.shift()
        }
        // 末尾【零】删掉
        if (resultAr[0] === '零') {
          resultAr.pop()
        }
        resultAr.push(unitAr[idx++])
        if (index !== 0) {
          turnNum(num, percent * 10, --index)
        }
      }
    }
    turnNum(num, percent, index)
    return resultAr.reverse().join('')
  },

  // 数字转中文大写（含小数）
  number_chinese(str) {
    var num = parseFloat(str);
    var strOutput = "",
      strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
    num += "00";
    var intPos = num.indexOf('.');
    if (intPos >= 0) {
      num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
    }
    strUnit = strUnit.substr(strUnit.length - num.length);
    for (var i = 0; i < num.length; i++) {
      strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
    }
    return strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")

  },

  //金额类型转换千分位
  getNum(value) {
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  },
}